// src/services/nwsAlerts.js
// Fetches active NWS (National Weather Service) alerts for a given lat/lon.
// Uses the same api.weather.gov base that WeatherConditions already uses.

/**
 * Fetch active NWS alerts for a point.
 * @param {number} lat
 * @param {number} lon
 * @returns {Promise<object[]>} Array of alert feature objects
 */
export async function fetchNWSAlerts(lat, lon) {
  const WEATHER_API_BASE = process.env.REACT_APP_WEATHER_API || "https://api.weather.gov";
  const url = `${WEATHER_API_BASE}/alerts/active?point=${lat},${lon}`;
  const res = await Promise.race([
    fetch(url, {
      headers: { "User-Agent": "(outdoorec-app, contact@outdoorec.com)" },
    }),
    new Promise((_, reject) =>
      setTimeout(() => reject(new Error("NWS alerts fetch timeout")), 12000)
    ),
  ]);
  if (!res.ok) {
    throw new Error(`NWS alerts error: ${res.status}`);
  }
  const json = await res.json();
  // Return the features array (each has .properties with severity, event, headline, etc.)
  return (json.features || []).map((f) => f.properties);
}
